import React from 'react';

const NewReleases = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.67132 3.25462C7.30239 1.94248 5.12594 1.98512 3.81101 3.34885L3.3726 3.80353L3.82906 4.24106C5.19799 5.55319 7.37444 5.51055 8.68937 4.14683L9.12778 3.69214L8.67132 3.25462ZM2.9116 2.48162C4.70491 0.621753 7.67029 0.564455 9.53587 2.35264L10.4447 3.22373C10.5645 3.3386 10.6337 3.49644 10.637 3.66241C10.6373 3.68092 10.6369 3.69936 10.6356 3.71769C11.1263 5.59564 12.0732 7.32154 13.39 8.74297C13.7623 8.60996 14.1633 8.53753 14.5813 8.53753C16.5364 8.53753 18.1213 10.1224 18.1213 12.0775C18.1213 14.0326 16.5364 15.6175 14.5813 15.6175C12.6262 15.6175 11.0413 14.0326 11.0413 12.0775C11.0413 10.9989 11.5237 10.033 12.2845 9.38366C11.1619 8.11814 10.2975 6.64692 9.7383 5.05318L9.12208 5.80635C7.74998 7.48336 6.85427 9.49475 6.5236 11.6298C7.93589 12.0949 8.95539 13.4248 8.95539 14.9929C8.95539 16.9479 7.37048 18.5329 5.41539 18.5329C3.4603 18.5329 1.87539 16.9479 1.87539 14.9929C1.87539 13.081 3.39104 11.5231 5.28635 11.4552C5.56601 9.63431 6.21821 7.89462 7.19778 6.34344C5.72691 6.65758 4.13079 6.26094 2.9645 5.14304L2.05571 4.27195C1.93587 4.15708 1.86667 3.99923 1.8634 3.83326C1.86013 3.66729 1.92306 3.50684 2.03828 3.38734L2.9116 2.48162ZM12.2907 12.0775C12.2907 10.8125 13.3163 9.78694 14.5813 9.78694C15.8464 9.78694 16.8719 10.8125 16.8719 12.0775C16.8719 13.3426 15.8464 14.3681 14.5813 14.3681C13.3163 14.3681 12.2907 13.3426 12.2907 12.0775ZM3.1248 14.9929C3.1248 13.7278 4.15033 12.7023 5.41539 12.7023C6.68045 12.7023 7.70598 13.7278 7.70598 14.9929C7.70598 16.2579 6.68045 17.2834 5.41539 17.2834C4.15033 17.2834 3.1248 16.2579 3.1248 14.9929Z",
      fill: "white"
    }
  )
);

export { NewReleases };
//# sourceMappingURL=NewReleases.js.map
